import { ENTRY_WIDTH_UNIT } from '../../../../constants/styling/styles';
import React, { Component } from 'react';
import { differenceInMinutes, msToHour } from '../../../../lib/date.utils';
import States from './States';
import { getClearingForPartner, displayEntry } from '../../../../selectors/events/timetable';
import { v4 as uuidv4 } from 'uuid';

import FavoriteStar from '../../events/FavoriteStar';

class Entry extends Component {
    shouldComponentUpdate(nextProps) {
        this._entryToUniqueString(nextProps.entry);
        return (
            this.props.favoriteArtists.length !== nextProps.favoriteArtists.length ||
            this.props.selectedPartner !== nextProps.selectedPartner ||
            this.props.isLiveView !== nextProps.isLiveView ||
            this.props.artistsFilters !== nextProps.artistsFilters ||
            this.props.liveFilters !== nextProps.liveFilters ||
            this.props.nonLinearFilters !== nextProps.nonLinearFilters ||
            this.props.zoom !== nextProps.zoom ||
            this._entryToUniqueString(nextProps.entry) !== this._entryToUniqueString(this.props.entry)
        );
    }
    _entryToUniqueString = entry =>
        `${entry.id}_${(entry.Artist && entry.Artist.id) || uuidv4()}_${entry.startHour}_${
            entry.endHour
        }_${JSON.stringify(entry.clearing || [])}`;

    _calculatePosition() {
        const difference = differenceInMinutes(this.props.minHour, this.props.entry.startHour);
        return (difference / 60) * (ENTRY_WIDTH_UNIT * this.props.zoom);
    }
    _calculateSize() {
        const difference = differenceInMinutes(this.props.entry.startHour, this.props.entry.endHour);
        return ENTRY_WIDTH_UNIT * this.props.zoom * (difference / 60);
    }
    _showEntry = () => {
        this.props.onClick({ ...this.props.entry, stage: this.props.stage, day: this.props.day });
    };

    render() {
        const { artistsFilters, liveFilters, nonLinearFilters, favoriteArtists } = this.props;
        const clearing = getClearingForPartner(this.props.entry, this.props.selectedPartner);
        const artist = this.props.entry.Artist || {};
        const display = displayEntry(artist.name || '', clearing, artistsFilters, liveFilters, nonLinearFilters);
        const isFavorite = favoriteArtists.includes(artist.id);

        return (
            <a
                className={`ckp-timetable-entry ${display ? '' : 'is-hidden'}`}
                style={{ left: this._calculatePosition(), width: this._calculateSize() }}
            >
                <li className="ckp-timetable-entry-container" onClick={this._showEntry}>
                    <FavoriteStar
                        favOrUnfavArtist={this.props.favOrUnfavArtist}
                        artistId={artist.id}
                        isFavorite={isFavorite}
                    />
                    <span className="ckp-timetable-entry-artist u-truncate">{(artist && artist.name) || ''}</span>
                    <span className="ckp-timetable-entry-hour">{`${msToHour(this.props.entry.startHour)} - ${msToHour(
                        this.props.entry.endHour
                    )}`}</span>
                    <States isLiveView={this.props.isLiveView} clearing={clearing} />
                </li>
            </a>
        );
    }
}

export default Entry;



// WEBPACK FOOTER //
// ./src/components/application/timetable/entries/Entry.js